import React from 'react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';

const WhatsAppButton = () => {
  return (
    <FloatingWhatsApp
      phoneNumber="905327763999"
      accountName="Ulus İnşaat"
      avatar="/images/ulus-logo-black.svg"
      statusMessage="Genellikle birkaç dakika içinde yanıt verir"
      chatMessage="Merhaba! 🤝 Size nasıl yardımcı olabiliriz?"
      placeholder="Mesajınızı yazın..."
      allowClickAway
      allowEsc
      notification
      notificationDelay={60}
      chatboxHeight={360}
      style={{ zIndex: 9999 }}
      chatboxStyle={{ zIndex: 9999 }}
      chatboxClassName="ulus-whatsapp-chatbox"
    />
  );
};

export default WhatsAppButton;
